module.exports = __webpack_public_path__ + "img/home-img2.b148412f.png";